import { render, staticRenderFns } from "./PageBlogCategory.vue?vue&type=template&id=7fbc13aa&"
import script from "./PageBlogCategory.vue?vue&type=script&lang=js&"
export * from "./PageBlogCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7fbc13aa')) {
      api.createRecord('7fbc13aa', component.options)
    } else {
      api.reload('7fbc13aa', component.options)
    }
    module.hot.accept("./PageBlogCategory.vue?vue&type=template&id=7fbc13aa&", function () {
      api.rerender('7fbc13aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/blogCategory/PageBlogCategory.vue"
export default component.exports